import React, { useState, useEffect } from 'react';
import FliterBlock from '../../common/filterBlock/Filter';
import InfiniteScroll from "react-infinite-scroll-component";
import { apis } from '../../services/Api';
import Card from '../../common/card/Card';
import { connect } from 'react-redux';
import { useLocation } from "react-router-dom";
import './CatalogStyle.css';


function Catalog(props) {

    let [courseList, setCourseList] = useState([]);
    let [hasMore, setHasMore] = useState(true);
    let [cursor, setCursor] = useState();
    let [filter, setFilter] = useState(null);
    let [shortBy, setShortBy] = useState('name');
    let [styleType] = useState([
        {
            id: 1,
            className: "catalog-block"
        },
        {
            id: 2,
            className: "catalog-block catalog-listview"
        },

    ]);
    let [selectedStyle, setSelectedStyle] = useState({
        id: 1,
        className: "catalog-block"
    });
    let [noData, setNoData] = useState(false);
    const location = useLocation();


    useEffect(() => {
        apiCall()
    }, [filter, shortBy]);

    const apiCall = async (c) => {
        let { links, data } = await apis.getLearningObjects(10, c, shortBy, filter);
        //console.log(links);
        //console.log(data);

        if (!links.next) {
            setHasMore(false);
        } else {
            const urlParams = new URLSearchParams(links.next);
            const nextCursor = urlParams.get('page[cursor]');
            setCursor(nextCursor);
            setHasMore(true);
        }
        if (!c) {
            setCourseList([]);
            data.length > 0 ? setNoData(false) : setNoData(true);
        }
        for (let i = 0; i < data.length; i++) {
            setCourseList(oldArray => [...oldArray, {
                id: data[i].id,
                imageUrl: data[i].attributes.imageUrl,
                loFormat: data[i].attributes.loFormat,
                name: data[i].attributes.localizedMetadata[0].name,
                duration: data[i].attributes.duration,
                averageRating: data[i].attributes.rating.averageRating,
                enrollment: data[i].relationships.hasOwnProperty("enrollment") ? true : false,
                instancesId: data[i].relationships.instances.data[0].id,
                skills: findSkill(data[i].relationships.skills.data[0].id.split('_')[1])?.name || ''
            }]);
        }
    }

    const findSkill = (id) => {
        return props.skills.find((e) => {
            return e.id === id
        })
    }

    const nextCursor = () => {
        apiCall(cursor);
    }

    const onChangeFilter = (text) => {
        setFilter(text);
    }

    const onChangeShortBy = (text) => {
        setShortBy(text);
    }

    const enrollToCourse = async (cid, ciid) => {
        await apis.setEnrollment(cid, ciid);
        playCourse(cid);
    }

    const playCourse = (cid, mid) => {
        props.history.push({
            pathname: `/course-player`,
            state: {
                cid,
                mid,
                goBackUrl: location.pathname
            }
        });
    }

    const toggleStyle = (data) => {
        setSelectedStyle(styleType[data - 1]);
    }

    return (
        <React.Fragment>
            <div className='main-block'>
                <div className='container'>
                    <FliterBlock
                        onChangeFilter={onChangeFilter}
                        onChangeShortBy={onChangeShortBy}
                        selectedStyle={selectedStyle}
                        toggleStyle={toggleStyle}
                    />

                    <div className='catalog-listview-block'>
                        {/* show heading only list view */}
                        {
                            selectedStyle.id === 2 ? <div className='tableTitleBlock'>
                                <div className='tableTitle'>Title</div>
                                <div className='tableTitle'>Type</div>
                                <div className='tableTitle'>Duration</div>
                                <span className='tableTitle'>Rating</span>
                                <span className='tableTitle'>Action</span>
                            </div> : ""
                        }
                        <InfiniteScroll
                            dataLength={courseList.length}
                            next={() => nextCursor()}
                            hasMore={hasMore}
                            loader={<h4>Loading...</h4>}
                            className={selectedStyle.className}// dynamically add className for list and grid 
                            endMessage={<p style={{ textAlign: "center" }}><b></b></p>}
                        >
                            {!noData && courseList.map((e) => <Card key={e.id} data={e} enrollToCourse={enrollToCourse} />)}
                            {noData && <h1 className='no-data'>No data found</h1>}
                        </InfiniteScroll>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        skills: state.skills
    }
}


export default connect(mapStateToProps)(Catalog);